/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Start_TitleInputs */

const vi_cdo_start_title = /** @type {(inputs: Cdo_Start_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt đầu giao`)
};

/**

* @param {Cdo_Start_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_start_title = /** @type {((inputs?: Cdo_Start_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Start_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_start_title(inputs)
});